import React, { Suspense } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import DesktopTaxReturnLanding from './DesktopTaxReturnLanding';
import MobileTaxReturnLanding from './MobileTaxReturnLanding';

const TaxReturnLanding = () => {
  const isMobile = useIsMobile();

  return (
    <Suspense fallback={null}>
      {isMobile ? <MobileTaxReturnLanding /> : <DesktopTaxReturnLanding />}
    </Suspense>
  );
};

export default TaxReturnLanding;
